import React from 'react'
import LazyBg from '../components/LazyBg';

function Hotels() {
 return (
 <div>
 {/* Hero Header */}
 <LazyBg src="/assets/img/hotelh.jpg" className="container-fluid bg-primary py-5 mb-5 hero-header"
 style={{
 backgroundSize:"cover",
 backgroundPosition:"center",}}
 >
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">
 Nos Hôtels à l'étranger
 </h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/"style={{color:'#2B4C7E'}}>Accueil</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Hôtels
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </LazyBg>

 {/* Hotels Section */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Hébergements
 </h6>
 <h1 className="mb-5">Découvrez Nos Hôtels Premium</h1>
 </div>
 
 <div className="row g-4">
 {/* Hotel 1 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-1.jpg" alt="Hôtel Luxe Bangkok" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Bangkok, Thaïlande
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 5 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Royal Palace Hotel Bangkok</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <p className="mb-3">
 Luxueux hôtel au cœur de Bangkok avec vue panoramique sur la ville
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Chambre Deluxe
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 2 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-utensils text-primary me-2" />
 Petit-déjeuner inclus
 </small>
 <small>
 <i className="fa fa-swimming-pool text-primary me-2" />
 Piscine
 </small>
 </div>
 <h3 className="text-primary mb-3">350 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>

 {/* Hotel 2 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-2.jpg" alt="Hôtel Bali Paradise" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Bali, Indonésie
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 4 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Bali Paradise Resort</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-body" />
 </div>
 <p className="mb-3">
 Resort tropical avec accès direct à la plage et spa privé
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Suite Ocean View
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 2-3 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-spa text-primary me-2" />
 Spa inclus
 </small>
 <small>
 <i className="fa fa-umbrella-beach text-primary me-2" />
 Plage privée
 </small>
 </div>
 <h3 className="text-primary mb-3">280 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>

 {/* Hotel 3 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-3.jpg" alt="Hôtel Kuala Lumpur" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Kuala Lumpur, Malaisie
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 5 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Grand Hyatt Kuala Lumpur</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <p className="mb-3">
 Hôtel moderne avec vue sur les Tours Petronas et centre commercial
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Chambre Executive
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 2 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-dumbbell text-primary me-2" />
 Salle de sport
 </small>
 <small>
 <i className="fa fa-cocktail text-primary me-2" />
 Bar rooftop
 </small>
 </div>
 <h3 className="text-primary mb-3">420 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>

 {/* Hotel 4 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/destination-4.jpg" alt="Hôtel Sydney" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Sydney, Australie
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 4 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Sydney Harbour View Hotel</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-body" />
 </div>
 <p className="mb-3">
 Vue imprenable sur l'Opéra de Sydney et le Harbour Bridge
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Chambre Standard
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 2 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-utensils text-primary me-2" />
 Restaurant
 </small>
 <small>
 <i className="fa fa-parking text-primary me-2" />
 Parking
 </small>
 </div>
 <h3 className="text-primary mb-3">380 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>

 {/* Hotel 5 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/destination-1.jpg" alt="Hôtel Phuket" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Phuket, Thaïlande
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 5 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Andaman Beach Resort</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <p className="mb-3">
 Resort de luxe en bord de mer avec villas privées
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Villa Piscine Privée
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 4 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-concierge-bell text-primary me-2" />
 Service conciergerie
 </small>
 <small>
 <i className="fa fa-water text-primary me-2" />
 Sports nautiques
 </small>
 </div>
 <h3 className="text-primary mb-3">550 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>

 {/* Hotel 6 */}
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/destination-2.jpg" alt="Hôtel Langkawi" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Langkawi, Malaisie
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-star text-primary me-2" />
 4 Étoiles
 </small>
 </div>
 <div className="text-center p-4">
 <h4 className="mb-3">Tropical Island Resort</h4>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-body" />
 </div>
 <p className="mb-3">
 Resort familial avec activités pour enfants et adultes
 </p>
 <div className="mb-3">
 <small className="border-end me-3 pe-3">
 <i className="fa fa-bed text-primary me-2" />
 Chambre Familiale
 </small>
 <small className="border-end me-3 pe-3">
 <i className="fa fa-user text-primary me-2" />
 4 Personnes
 </small>
 <small>
 <i className="fa fa-wifi text-primary me-2" />
 WiFi Gratuit
 </small>
 </div>
 <div className="mb-3">
 <small className="me-3">
 <i className="fa fa-child text-primary me-2" />
 Club enfants
 </small>
 <small>
 <i className="fa fa-utensils text-primary me-2" />
 All inclusive
 </small>
 </div>
 <h3 className="text-primary mb-3">320 TND / Nuit</h3>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Détails
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* Features Section */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Avantages
 </h6>
 <h1 className="mb-5">Pourquoi Réserver Avec Nous</h1>
 </div>
 <div className="row g-4">
 <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="service-item rounded pt-3">
 <div className="p-4 text-center">
 <i className="fa fa-3x fa-tag text-primary mb-4" />
 <h5>Meilleurs Prix Garantis</h5>
 <p>Prix compétitifs et offres exclusives sur tous nos hôtels partenaires</p>
 </div>
 </div>
 </div>
 <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
 <div className="service-item rounded pt-3">
 <div className="p-4 text-center">
 <i className="fa fa-3x fa-shield-alt text-primary mb-4" />
 <h5>Réservation Sécurisée</h5>
 <p>Paiement 100% sécurisé et protection de vos données personnelles</p>
 </div>
 </div>
 </div>
 <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="service-item rounded pt-3">
 <div className="p-4 text-center">
 <i className="fa fa-3x fa-headset text-primary mb-4" />
 <h5>Support 24/7</h5>
 <p>Assistance disponible à tout moment pour votre tranquillité d'esprit</p>
 </div>
 </div>
 </div>
 
 </div>
 </div>
 </div>
 </div>
 )
}

export default Hotels